type PaginationProps = {
  page: number;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
};

export function Pagination({ page, hasNext, onPrev, onNext, disabled }: PaginationProps) {
  return (
    <div className="pagination-controls">
      <button
        type="button"
        className="secondary-btn"
        onClick={onPrev}
        disabled={disabled || page <= 1}
      >
        Previous
      </button>
      <span className="pagination-page">Page {page}</span>
      <button type="button" className="secondary-btn" onClick={onNext} disabled={disabled || !hasNext}>
        Next
      </button>
    </div>
  );
}
